module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'clusters'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('../assets/section1.png')
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-806b775a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 120
// module chunks = 0